import type { RouterConfig } from '@nuxt/schema'

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

function nextPaint() {
  return new Promise<void>((resolve) => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve()))
  })
}

export default {
  async scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (document.documentElement.dataset.ticketDirection && to.name === from.name) return false

    if (to.hash) {
      await nextPaint()
      const target = document.getElementById(decodeURIComponent(to.hash.slice(1)))
      if (target) {
        const topbarHeight = [...document.querySelectorAll<HTMLElement>('.public-topbar, [data-sticky-header]')]
          .reduce((height, element) => height + element.getBoundingClientRect().height, 0)
        return {
          top: Math.max(
            0,
            window.scrollY + target.getBoundingClientRect().top - topbarHeight - 18
          ),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        }
      }
    }

    const changedRightsView = to.path === from.path
      && to.path.endsWith('/account/rights')
      && to.query.view !== from.query.view
    if (changedRightsView) await nextPaint()
    if (to.path !== from.path || changedRightsView) {
      return {
        top: 0,
        behavior: /\/account(?:\/|$)/.test(to.path) || prefersReducedMotion() ? 'auto' : 'smooth'
      }
    }

    return false
  }
} satisfies RouterConfig
